import { CreateAxiosInstance } from '@eta/components';
import { IContentManagementClient, ContentManagementClient } from './proxy';
import { authService } from '../../Security/Security';
import { EnsureNotSlashAtEnd } from '../../helpers/UIHelpers';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const publicPortalUrl = EnsureNotSlashAtEnd((window as any).REACT_APP_PublicGatewayApiBaseURL);

export class ServiceCreator {


    public static getContentManagementClient(
            anonymousCall = false
        ): IContentManagementClient {
        return new ContentManagementClient({
            authService,
            apiGatewayUrl: publicPortalUrl,
            apiVersion: 1,
            enableAnonymousCall: anonymousCall,
        },undefined, CreateAxiosInstance(true));
    }
}
